import { useEffect, useState } from 'react';
import {
  TextField,
  Button,
  FormControl,
  Box,
  Grid,
  InputAdornment,
  IconButton,
  Typography,
} from '@material-ui/core';
import { connect } from 'react-redux';

import DoctorAppointmentCard from './DoctorAppointmentCard';
import { useStyles } from './style';
import { doctorsActionsTypes } from '../../redux/doctor/actions';
import { userActionsTypes } from '../../redux/user/actions';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Pagination from '@material-ui/lab/Pagination';
import { appointmentActionsTypes } from '../../redux/appointment/actions';
import DoctariSpinner from '../../components/Spinner';
import moment from 'moment-timezone';
import { SearchOutlined, SettingsBackupRestore } from '@material-ui/icons';
import { useTheme } from '@material-ui/core/styles';
import { getSlotsRange } from '../../utils/helpers';
import DoctariModal from '../../components/Modal';
import Notification from '../../components/Notification';

const AssistantDoctorsAppointment = ({
  clearSelectedDoctor,
  userData,
  getUserData,
  session,
  doctorInfo,
  setSelectedDoctor,
  getAppointmentsLight,
  appointmentsData,
  getSchedulesByDate,
  updateAppointmentLight,
  deleteMessages,
  resendVideoCode,
}) => {
  const classes = useStyles();
  const theme = useTheme();

  useEffect(() => {
    getUserData(session.userType, session.id);
  }, []);

  const [state, setState] = useState({
    userLoad: false,
    doctorFullData: null,
    doctorId: null,
  });
  const [filterState, setFilterState] = useState({
    fromDate: null,
    toDate: null,
    patientName: null,
    doctorFilter: null,
    currentPage: 1,
    doctorName: null,
  });
  const {
    fromDate,
    toDate,
    patientName,
    doctorFilter,
    currentPage,
    doctorName,
  } = filterState;
  const { userLoad, doctorFullData, doctorId } = state;
  const { appointments, numOfPages, schedules } = appointmentsData;
  const [doctorsIds, setDoctorsIds] = useState('');
  const [appointmentsLoading, setAppointmentsLoading] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [appointmentReason, setAppointmentReason] = useState('');
  const [scheduleHour, setScheduleHour] = useState();
  const [hours, setHours] = useState([]);
  const [doctorAppointment, setDoctorAppointment] = useState();
  const [disabledHours, setDisabledHours] = useState([]);
  const [selectedDate, setSelectedDate] = useState();
  const [openModalAppointmentCancelled, setOpenModalAppointmentCancelled] =
    useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (toDate || fromDate || patientName || doctorName || currentPage) {
      searchAppointments();
    }
    /* return () => clearAppointments(); */
  }, [toDate, fromDate, patientName, doctorName, currentPage]);

  // useEffect(() => {
  //   if (session && session.email) {
  //     getAppointmentsLight(session.userType, session.id, true, [], []);
  //   }
  // }, []);

  useEffect(() => {
    if (userData.user) {
      if (userData.user.doctors) {
        setState({
          ...state,
          userLoad: true,
        });
        let ids = '';
        for (let i = 0; i < userData.user.doctors.length; i++) {
          if (i == userData.user.doctors.length - 1) {
            ids = ids + userData.user.doctors[i].id;
          } else {
            ids = ids + userData.user.doctors[i].id + ',';
          }
        }
        setDoctorsIds(ids);
        // getAppointmentsLight('doctor__in', ids, false, [], []);
      }
    }
  }, [userData.user]);

  const searchAppointments = () => {
    setAppointmentsLoading(true);
    let queryParams = [];
    let queryValues = [];
    if (currentPage > 1) {
      queryParams.push('page');
      queryValues.push(currentPage);
    }
    if (fromDate) {
      queryParams.push('date__gt');
      let fromDateFormatted = moment(fromDate)
        .set('hour', '00')
        .set('minute', '00')
        .tz(process.env.REACT_APP_API_TIMEZONE || 'America/Montevideo')
        .format('YYYY-MM-DD HH:mm');
      queryValues.push(fromDateFormatted);
    }
    if (toDate) {
      queryParams.push('date__lt');
      let toDateFormatted = moment(toDate)
        .set('hour', '23')
        .set('minute', '59')
        .tz(process.env.REACT_APP_API_TIMEZONE || 'America/Montevideo')
        .format('YYYY-MM-DD HH:mm');
      queryValues.push(toDateFormatted);
    }
    if (doctorName) {
      queryParams.push('doctor__full_name__icontains');
      queryValues.push(doctorName);
    }
    if (patientName) {
      queryParams.push('patient__full_name__icontains');
      queryValues.push(patientName);
    }
    getAppointmentsLight(
      'doctor__in',
      doctorsIds,
      false, //isDone,
      queryParams,
      queryValues
    );
  };

  useEffect(() => {
    // if (currentPage > 1) {
    //   getAppointments('doctor__in', ids, false, [], []);
    // }
    if (
      // doctorsIds ||
      appointmentsData.success.genericMessage ===
      'Appointment actualizado con exito'
    ) {
      setState({
        userLoad: false,
        doctorFullData: null,
        doctorId: null,
      });
      searchAppointments();
      setOpenModal(false);
      setOpenModalAppointmentCancelled(false);
      setLoading(false);
    }
  }, [appointmentsData.success.genericMessage]);

  useEffect(() => {
    if (appointments?.length > 0) {
      setAppointmentsLoading(false);
    }
  }, [appointments]);

  useEffect(() => {
    if (doctorAppointment) {
      // getSchedulesByDate(
      //   moment()
      //     .day(1)
      //     .set('hour', '00')
      //     .set('minute', '00')
      //     .add(0, 'days')
      //     .format('YYYY-MM-DD HH:mm'),
      //   moment().day(1).add(7, 'days').format('YYYY-MM-DD HH:mm'),
      //   doctorAppointment.doctor.id
      // );
      setState({
        ...state,
        doctorId: doctorAppointment.doctor.id,
        doctorFullData: doctorAppointment.doctor,
      });

      setSelectedDate(
        moment(doctorAppointment.schedule.start)
          .tz(moment.tz.guess())
          .format('YYYY-MM-DD')
      );
      setScheduleHour(
        moment(doctorAppointment.schedule.start)
          .tz(moment.tz.guess())
          .format('HH:mm')
      );
    }
  }, [doctorAppointment]);

  useEffect(() => {
    if (schedules) {
      setDisabledHours(
        Object.keys(schedules).map((key, index) => {
          if (schedules[key][0].taken) {
            return moment(key).tz(moment.tz.guess()).format('HH:mm');
          }
        })
      );
    }
  }, [schedules]);

  useEffect(() => {
    if (selectedDate) {
      let fromDateFormatted = moment(selectedDate)
        .set('hour', '00')
        .set('minute', '00')
        .tz(process.env.REACT_APP_API_TIMEZONE || 'America/Montevideo')
        .format('YYYY-MM-DD HH:mm');
      let toDateFormatted = moment(selectedDate)
        .set('hour', '23')
        .set('minute', '59')
        .tz(process.env.REACT_APP_API_TIMEZONE || 'America/Montevideo')
        .format('YYYY-MM-DD HH:mm');
      getSchedulesByDate(
        fromDateFormatted,
        toDateFormatted,
        doctorId ? doctorId : doctorAppointment.doctor.id
      );
    }
  }, [selectedDate, doctorId]);

  useEffect(() => {
    if (doctorId) {
      setHours(getSlotsRange(doctorFullData.specialty.duration.minutes));
    }
  }, [doctorId]);

  const handleChangeDoctorId = (e, value) => {
    if (value == null) {
      // clearSelectDoctor();
      setState({
        ...state,
        doctorId: null,
        doctorFullData: null,
      });
    } else {
      setState({
        ...state,
        doctorId: value.id,
        doctorFullData: value,
      });
    }
  };

  const handleInputChange = (e) => {
    setAppointmentReason(e.target.value);
  };

  const handleSetHour = (e, value) => {
    if (value == null) {
      setScheduleHour(null);
    } else {
      setScheduleHour(value);
    }
  };

  const handlePatchAppointmentLight = (isCancelled = false) => {
    setLoading(true);
    let body;
    if (isCancelled) {
      body = {
        status: 'cancelled',
        is_cancelled: true,
      };
    } else {
      body = {
        doctor: doctorId ? doctorId : doctorAppointment.doctor.id,
        schedule_hour:
          moment(selectedDate + ' ' + scheduleHour).format(
            'YYYY-MM-DD HH:mm'
          ) != 'Fecha inválida'
            ? moment(selectedDate + ' ' + scheduleHour)
                .tz(moment.tz.guess())
                .format()
            : doctorAppointment.schedule.start,
        patient_appointment_reason: appointmentReason
          ? appointmentReason
          : doctorAppointment.patient_appointment_reason,
      };
    }
    updateAppointmentLight(doctorAppointment.id, body);
  };

  return (
    <>
      {appointmentsData.success.genericMessage ===
        'Appointment actualizado con exito' && (
        <Notification
          type='success'
          message={'Consulta actualizada con éxito'}
          onCloseCallback={deleteMessages}
        />
      )}
      {appointmentsData.success.genericMessage ===
        'Datos reenviados con exito' && (
        <Notification
          type='success'
          message={'Datos reenviados con éxito'}
          onCloseCallback={deleteMessages}
        />
      )}
      <DoctariModal
        open={openModal}
        setOpen={(val) => setOpenModal(val)}
        title={'Modificar consulta'}
      >
        <Grid
          container
          direction='row'
          justifyContent='center'
          alignItems='center'
          spacing={2}
          style={{ padding: '2rem', width: '100%' }}
        >
          <Grid
            item
            xs={12}
            md={6}
            // style={{
            //   display: 'flex',
            //   justifyContent: 'center',
            //   alignItems: 'center',
            // }}
          >
            <Autocomplete
              disablePortal
              id='combo-box-demo'
              options={
                userData?.user?.doctors?.length > 0
                  ? userData.user.doctors.filter((doctor) => {
                      return doctor.is_active;
                    })
                  : []
              }
              getOptionLabel={(option) => option.full_name}
              sx={{ width: 300 }}
              value={doctorFullData ? doctorFullData : null}
              onChange={handleChangeDoctorId}
              renderInput={(params) => (
                <TextField {...params} label='Seleccione doctor' />
              )}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              id='standard-basic'
              label='Motivo de la consulta'
              variant='standard'
              style={{ width: '100%' }}
              // className={styles.paperGridItems}
              onChange={handleInputChange}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <FormControl style={{ width: '100%' }}>
              <TextField
                id='fromDateSelected'
                label='Fecha de consulta'
                type={!selectedDate ? 'text' : 'date'}
                value={selectedDate ? selectedDate : ''}
                onChange={(e) => setSelectedDate(e.target.value)}
                onFocus={(e) => (e.target.type = 'date')}
                onBlur={(e) =>
                  (e.target.type = !selectedDate ? 'text' : 'date')
                }
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6}>
            <Autocomplete
              disablePortal
              id='combo-box-demo'
              options={hours ? hours : []}
              // getOptionLabel={(option) => option.full_name}
              getOptionDisabled={(option) =>
                !!disabledHours.find((element) => element === option) ||
                moment(
                  moment().tz(moment.tz.guess()).format('YYYY-MM-DD HH:mm')
                ).isSameOrAfter(
                  moment(selectedDate + ' ' + option).format('YYYY-MM-DD HH:mm')
                )
              }
              sx={{ width: 300 }}
              value={scheduleHour ? scheduleHour : ''}
              onChange={handleSetHour}
              disabled={!selectedDate}
              renderInput={(params) => (
                <TextField {...params} label='Seleccione hora' />
              )}
            />
          </Grid>
          {moment(
            moment().tz(moment.tz.guess()).format('YYYY-MM-DD HH:mm')
          ).isSameOrAfter(
            moment(selectedDate + ' ' + scheduleHour).format('YYYY-MM-DD HH:mm')
          ) && (
            <Grid item xs={12}>
              <Typography variant='subtitle2' color='error'>
                La fecha seleccionada es pasada a la actual
              </Typography>
            </Grid>
          )}
        </Grid>
        <Box
          style={{ display: 'flex', justifyContent: 'end', padding: '2rem' }}
        >
          <Button
            variant='contained'
            color='primary'
            onClick={() => handlePatchAppointmentLight()}
            disabled={moment(
              moment().tz(moment.tz.guess()).format('YYYY-MM-DD HH:mm')
            ).isSameOrAfter(
              moment(selectedDate + ' ' + scheduleHour).format(
                'YYYY-MM-DD HH:mm'
              )
            )}
          >
            {appointmentsData.loading ? 'Cargando...' : 'Aceptar'}
          </Button>
        </Box>
      </DoctariModal>
      <DoctariModal
        open={openModalAppointmentCancelled}
        setOpen={(val) => setOpenModalAppointmentCancelled(val)}
        title={'Confirmacion de cancelación'}
      >
        <Box
          style={{ display: 'flex', justifyContent: 'center', padding: '1rem' }}
        >
          <Typography>¿Estas seguro que desea cancelar la consulta?</Typography>
        </Box>
        <Box
          style={{
            display: 'flex',
            justifyContent: 'end',
            padding: '2rem',
            gap: '1rem',
          }}
        >
          <Button
            variant='contained'
            color='primary'
            onClick={() => setOpenModalAppointmentCancelled(false)}
          >
            Cancelar
          </Button>
          <Button
            variant='contained'
            color='primary'
            onClick={() => handlePatchAppointmentLight(true)}
          >
            {loading ? 'Cargando...' : 'Aceptar'}
          </Button>
        </Box>
      </DoctariModal>
      <Grid container style={{ display: 'block', marginTop: '2rem' }}>
        <div className={classes.generalContainer}>
          <Grid className={classes.formContainer}>
            <span style={{ fontWeight: 400, fontSize: '24px' }}>
              Buscar historial
            </span>
            {/*   <FormControl className={classes.select}>
          <Autocomplete
            disablePortal
            id="combo-box-demo"
            options={
              userLoad
                ? userData.user.doctors.filter((doctor) => {
                    return doctor.is_active;
                  })
                : []
            }
            getOptionLabel={(option) => option.full_name}
            sx={{ width: 300 }}
            value={doctorFilter ? doctorFilter : null}
            onChange={handleFilterDoctor}
            renderInput={(params) => (
              <TextField {...params} label="Seleccione doctor" />
            )}
          />
        </FormControl> */}
            <TextField
              className={classes.search}
              InputProps={{
                startAdornment: (
                  <InputAdornment>
                    <IconButton>
                      <SearchOutlined />
                    </IconButton>
                  </InputAdornment>
                ),
                style: {
                  height: '46px',
                },
                classes: { underline: classes.underline },
              }}
              id='my-input'
              placeholder='Nombre de paciente'
              variant='standard'
              autoComplete='off'
              style={{ marginBottom: '0' }}
              value={patientName}
              onChange={(e) =>
                setFilterState({
                  ...filterState,
                  patientName: e.target.value,
                  currentPage: 1,
                })
              }
            />
            <TextField
              className={classes.search}
              InputProps={{
                startAdornment: (
                  <InputAdornment>
                    <IconButton>
                      <SearchOutlined />
                    </IconButton>
                  </InputAdornment>
                ),
                style: {
                  height: '46px',
                },
                classes: { underline: classes.underline },
              }}
              id='my-input'
              placeholder='Nombre de doctor'
              variant='standard'
              autoComplete='off'
              value={doctorName}
              onChange={(e) =>
                setFilterState({
                  ...filterState,
                  doctorName: e.target.value,
                  currentPage: 1,
                })
              }
            />
            <Grid item className={classes.gridItem}>
              <FormControl className={classes.formControl}>
                <TextField
                  id='fromDate'
                  label='Desde'
                  type='date'
                  value={fromDate}
                  onChange={(e) =>
                    setFilterState({ ...filterState, fromDate: e.target.value })
                  }
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </FormControl>
            </Grid>
            <Grid item className={classes.gridItem}>
              <FormControl className={classes.formControl}>
                <TextField
                  id='toDate'
                  label='Hasta'
                  type='date'
                  value={toDate}
                  onChange={(e) =>
                    setFilterState({
                      ...filterState,
                      toDate: e.target.value,
                      currentPage: 1,
                    })
                  }
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </FormControl>
            </Grid>
            <Grid className={classes.buttonContainer}>
              <Button
                variant='contained'
                onClick={() => {
                  setFilterState({
                    ...filterState,
                    toDate: '',
                    fromDate: '',
                    patientName: '',
                    doctorName: '',
                    currentPage: 1,
                  });
                  // getAppointmentsLight('doctor__in', doctorsIds, false, [], []);
                }}
                style={{
                  color: 'white',
                  backgroundColor: '#666666',
                }}
              >
                <SettingsBackupRestore />
                Reiniciar
              </Button>
              <Button
                variant='contained'
                onClick={() => searchAppointments()}
                style={{
                  color: 'white',
                  backgroundColor: theme.palette.primary.main,
                  marginLeft: 'auto',
                }}
              >
                Filtrar
              </Button>
            </Grid>
          </Grid>
          <Grid className={classes.cardContainer}>
            {appointmentsData.loading ? (
              <DoctariSpinner />
            ) : appointments.length > 0 ? (
              appointments.map((appointment) => {
                return (
                  <DoctorAppointmentCard
                    appointment={appointment}
                    setOpenModal={setOpenModal}
                    setDoctorAppointment={setDoctorAppointment}
                    setOpenModalAppointmentCancelled={
                      setOpenModalAppointmentCancelled
                    }
                    resendVideoCode={resendVideoCode}
                  />
                );
              })
            ) : (
              <h3>No hay consultas</h3>
            )}

            <Pagination
              style={{
                display: 'flex',
                justifyContent: 'center',
                marginTop: '2rem',
                marginBottom: '2rem',
              }}
              page={currentPage}
              count={numOfPages}
              onChange={(_, page) => {
                if (currentPage !== page) {
                  setFilterState({ ...filterState, currentPage: page });
                }
              }}
              variant='outlined'
              color='primary'
            />
          </Grid>
        </div>
      </Grid>
    </>
  );
};

const mapStateToProps = ({ session, user, doctors, appointments }) => {
  return {
    session,
    userData: user,
    doctorInfo: doctors,
    appointmentsData: appointments,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getDoctorsInfo: (queryParams, queryValues) =>
    dispatch({
      type: doctorsActionsTypes.GET_DOCTORS,
      payload: { queryParams, queryValues },
    }),
  getUserData: (type, id) =>
    dispatch({ type: userActionsTypes.GET_USER, payload: { type, id } }),
  setSelectedDoctor: (doctorBody) =>
    dispatch({
      type: doctorsActionsTypes.SET_DOCTOR_BODY,
      payload: doctorBody,
    }),
  clearSelectedDoctor: () =>
    dispatch({ type: doctorsActionsTypes.CLEAR_SELECT_DOCTOR }),
  getAppointments: (userType, id, isDone, queryParams, queryValues) => {
    dispatch({
      type: appointmentActionsTypes.GET_APPOINTMENTS, //TODO cambiar el formato de fechas en el back para no tener que hacer todo este juego con format
      payload: {
        userType,
        id,
        isDone,
        queryParams,
        queryValues,
      },
    });
  },
  getAppointmentsLight: (userType, id, isDone, queryParams, queryValues) =>
    dispatch({
      type: appointmentActionsTypes.GET_APPOINTMENTS_LIGHT,
      payload: {
        userType,
        id,
        isDone,
        queryParams,
        queryValues,
      },
    }),
  getSchedulesByDate: (start, end, doctorId) =>
    dispatch({
      type: appointmentActionsTypes.GET_SCHEDULES_BY_DATE,
      payload: {
        start,
        end,
        doctorId,
      },
    }),
  updateAppointmentLight: (id, body) =>
    dispatch({
      type: appointmentActionsTypes.UPDATE_APPOINTMENT_LIGHT,
      payload: { id, body },
    }),
  deleteMessages: () =>
    dispatch({
      type: userActionsTypes.DELETE_MESSAGES,
    }),
  resendVideoCode: (id) => {
    dispatch({
      type: appointmentActionsTypes.RESEND_CODE,
      payload: { id },
    });
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AssistantDoctorsAppointment);
